import React from 'react'

import { SvgProps } from './types'

function Eye3Svg({ width, height, className, stroke, strokeColor }: SvgProps) {
  return (
    <svg
      className={className}
      width={width || '48'}
      height={height || '48'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      stroke={strokeColor}
      fill="none"
      strokeWidth={stroke || 1.6}
    >
      <path
        d="M9.99989 11.6663C10.4125 11.6663 10.8081 11.4907 11.0998 11.1782C11.3916 10.8656 11.5554 10.4417 11.5554 9.99967C11.5554 9.55765 11.3916 9.13372 11.0998 8.82116C10.8081 8.5086 10.4125 8.33301 9.99989 8.33301C9.58733 8.33301 9.19167 8.5086 8.89995 8.82116C8.60822 9.13372 8.44434 9.55765 8.44434 9.99967C8.44434 10.4417 8.60822 10.8656 8.89995 11.1782C9.19167 11.4907 9.58733 11.6663 9.99989 11.6663Z"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 10C15.5308 12.4925 12.8918 15 10 15C7.10822 15 4.46922 12.4925 3 10C4.78811 7.63167 6.88267 5 10 5C13.1173 5 15.2119 7.63167 17 10Z"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Eye3Svg
